if($('.video-object').length) {
    $('.video-object').each(function() {

        let filePath = $(this).data('video-file'),
            figure = $(this).parent('figure'),
            coverImage = figure.find('.video-cover-image');

        let videoObject = document.createElement("video");

        if (filePath.length) {
            let sourceMP4 = document.createElement("source");
            sourceMP4.type = "video/mp4";
            sourceMP4.src = filePath;
            videoObject.appendChild(sourceMP4);
        }

        videoObject.autoplay = true;
        videoObject.muted = true;
        videoObject.loop = true;
        videoObject.controls = true;
        videoObject.load();

        var playPromise = videoObject.play();

        if (playPromise !== undefined) {
            playPromise.then(function () {
                // Automatic playback started!
            }).catch(function (error) {
                // Automatic playback failed.
                // Show a UI element to let the user manually start playback.
            });
        }

        coverImage.fadeOut();
        $(this).append(videoObject);
        $(this).fadeIn();
    });
}
